


































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapState, mapMutations } from 'vuex';

@Component({
  computed: mapState(['metaElements']),
})
export default class Header extends Vue {
  get footerLinks() {
    return ['About', 'Legal'];
  }

  get shareItems() {
    return [
      {
        type: 'facebook',
        linkText: 'Share on Facebook',
        href: `https://www.facebook.com/sharer/sharer.php?u=${
          process.env.VUE_APP_URL
        }`,
      },
      {
        type: 'twitter',
        linkText: 'Share on Twitter',
        href: `https://twitter.com/share?url=${process.env.VUE_APP_URL}`,
      },
      {
        type: 'email',
        linkText: 'Share via e-mail',
        href: `mailto:?subject=The Elements of Basketball&body=${
          process.env.VUE_APP_URL
        }`,
      },
    ];
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Footer.vue